import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { addScenarioGroupFromAPI } from "../../actions/closeLoop/scenarioGroupActionCloseLoop";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import { deleteDb } from "../UserFunctions";
import { getScenarioGroupInfoCloseLoopInstanceDetail } from "../../components/UserFunctions";
import PropTypes from "prop-types";

class DeleteCloseLoopScenarioGroupModal extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        console.log(props.content.scenario_uuid);
        this.handleDeleteContent = this.handleDeleteContent.bind(this);

        this.state = {
            content: "",
        };
    }

    handleDeleteContent() {
        console.log(this.state.content);
        const delete_api_url = window.location.origin.concat("/delete_scenario_groups_close_loop");
        const data_for_api = {
            scenario_group_id: this.props.content.scenario_group_id,
        };
        deleteDb(delete_api_url, data_for_api)
            .then((res) => {
                console.log("Status of updation : ", res["data"]["status"]);
                if (res["data"]["status"] === "Deleted Successfully") {
                    getScenarioGroupInfoCloseLoopInstanceDetail().then((res) => {
                        if (res.data) {
                            this.props.dispatch(addScenarioGroupFromAPI(res));
                        }
                    });
                    this.setState(() => {
                        return {
                            error: "",
                        };
                    });
                    this.props.handleDeleteModalClose();
                }
            })
            .catch((error) => {
                this.setState(() => {
                    return {
                        error: error.response.data.message,
                    };
                });
            });
    }

    componentDidMount() {
        this.setState((prevState) => {
            if (this.props.content) {
                return {
                    ...prevState,
                    content: this.props.content,
                };
            } else {
                return {
                    content: "",
                };
            }
        });
    }

    render() {
        return (
            <Modal isOpen={!!this.props.deleteSelectedRow}>
                <ModalHeader
                    toggle={this.props.handleDeleteModalClose}
                    style={{ color: "#524fa1" }}
                >
                    Delete Scenario Group
                </ModalHeader>
                {this.state.error ? (
                    <Alert key="danger" variant="danger">
                        {this.state.error}
                    </Alert>
                ) : null}
                <ModalBody>
                    <div>Are you sure want to delete ?</div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-danger" style ={{color: "#FFFFFF"}} onClick={this.handleDeleteContent}>
                        Delete
                    </button>
                    <Button className="btn" style ={{color: "#FFFFFF"}}  onClick={this.props.handleDeleteModalClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
DeleteCloseLoopScenarioGroupModal.propTypes = {
    content: PropTypes.object,
    dispatch: PropTypes.func,
    handleDeleteModalClose: PropTypes.func,
    deleteSelectedRow: PropTypes.string,
};
DeleteCloseLoopScenarioGroupModal.defaultProps = {
    content: [],
    deleteSelectedRow: "",
};
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export default connect()(DeleteCloseLoopScenarioGroupModal);
